<template>
  <b-form class="font-inter">
    <BaseModal :name="name" :size="size" :title="title" @shown="onOpen">
      <b-row v-if="!loading">
        <b-col cols="12">
          <b-form-group :label="emailLabel">
            <b-input-group>
              <template #prepend>
                <b-input-group-text class="input-icon">
                  <font-awesome-icon icon="envelope" class="icon-gray" />
                </b-input-group-text>
              </template>
              <b-form-input
                v-model="localEmail"
                type="text"
                class="email-input"
                :placeholder="emailPlaceholder"
                v-validate="'required|email'"
                name="email"
                id="email"
              />
              <b-form-invalid-feedback :state="!errors.has('email')">
                {{ invalidEmailText }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:footer="{ cancel }">
        <BaseButton variant="link-info" class="mr-4" @click="cancel">
          {{ cancelText }}
        </BaseButton>
        <BaseButton @click="submit" variant="black" :disabled="errors.has('email') || loading">
          {{ submitText }}
        </BaseButton>
      </template>
      <div class="d-flex justify-content-center" v-if="loading">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <span v-if="note" style="color: #666;">
          <b-alert show variant="warning">
            {{ note }}
          </b-alert>
      </span>
    </BaseModal>
  </b-form>
</template>

<script>
export default {
  props: {
    name: { type: String, default: 'generic-export-modal' },
    size: { type: String, default: 'lg' },
    title: { type: String, default: 'Exportar' },
    email: { type: String, default: '' },
    emailLabel: { type: String, default: 'E-mail' },
    emailPlaceholder: { type: String, default: 'user@exemplo.com' },
    invalidEmailText: { type: String, default: 'Digite um e-mail válido' },
    cancelText: { type: String, default: 'Cancelar' },
    submitText: { type: String, default: 'Exportar' },
    loading: { type: Boolean, default: false },
    note: { type: String, default: '' },
    onSubmit: { type: Function, required: true },
    onOpen: { type: Function, default: () => {} }
  },
  data() {
    return {
      localEmail: this.email
    };
  },
  watch: {
    email(value) {
      this.localEmail = value;
    }
  },
  methods: {
    async submit() {
      const valid = await this.$validator.validate('email');

      if (!valid) {
        return;
      }
      this.onSubmit({ email: this.localEmail });
    }
  }
};
</script>

<style scoped>
  .email-input {
    border-left-width: 0;
    margin: 0;
    border-radius: 0 3px 3px 0 !important;
  }

  .email-input:hover,
  .email-input:focus {
    border-color: #ededf0 !important;
  }

  ::v-deep .input-icon {
    background-color: #fff  !important;
    border: 1px solid #ededf0;
    border-right: 0;
    margin: 0;
    padding-right: 1px;
    border-radius: 3px 0 0 3px;
    color: #495057;
  }
</style>